import React from 'react';
import { CheckCircleIcon, UserIcon } from 'lucide-react';
interface TestimonialCardRlt1Props {
  name: string;
  location: string;
  duration: string;
  testimonial: string;
}
const TestimonialCardRlt1 = ({
  name,
  location,
  duration,
  testimonial
}: TestimonialCardRlt1Props) => {
  return <div className="border-l-2 border-gray-800 pl-5 py-4 my-6 bg-gray-50 rounded-r shadow-sm" data-id="element-18216" data-mp="bbns87ioe7qb">
      <blockquote className="font-serif text-gray-700 italic mb-4 leading-relaxed text-base" data-id="element-18217" data-mp="6ckyhj85bnxn">
        "{testimonial}"
      </blockquote>
      <div className="flex items-center border-t border-gray-200 pt-3" data-id="element-18218" data-mp="1kjh5iw4f70r">
        <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center mr-2" data-id="element-18219" data-mp="3toc7n6d6zlm6">
          <UserIcon className="h-3 w-3 text-gray-600" data-id="element-18220" data-mp="3oqtut4w20m8w" />
        </div>
        <div className="text-sm text-gray-600" data-id="element-18221" data-mp="3jqy2i2wpyj96">
          <span className="font-medium text-gray-800" data-id="element-18222" data-mp="3jpmnf6xtpp2r">{name}</span>
          <span className="mx-1" data-id="element-18223" data-mp="3es4kbx6hm42o">•</span>
          <span data-id="element-18224" data-mp="3esefs0aax3fr">{location}</span>
          <span className="mx-1" data-id="element-18225" data-mp="3eu7conv449ak">•</span>
          <span data-id="element-18226" data-mp="2z6es5ps0oa0g">Using product for {duration}</span>
        </div>
        <div className="ml-2 flex items-center text-green-600 text-xs font-medium border border-green-200 rounded-full px-2 py-0.5 bg-green-50" data-id="element-18227" data-mp="33xeq8ycvgy4j">
          <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-18228" data-mp="2p9k11ry2pbw7" />
          <span data-id="element-18229" data-mp="2u7lhe5446x3z">Verified</span>
        </div>
      </div>
    </div>;
};
export default TestimonialCardRlt1;